var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundaboutLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600-120v-244q0-29 19-51t48-27q58-10 95.5-54.5T800-600q0-66-47-113t-113-47q-59 0-103.5 37.5T482-627q-5 29-27 48t-51 19H233l64 64-57 56L80-600l160-160 56 56-63 64h170q14-88 81.5-144T640-840q100 0 170 70t70 170q0 88-56 155.5T680-363v243h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundaboutLeft);
export default __webpack_public_path__ + "static/media/roundabout-left.c1048e2493b6a6c96739e9c8ad51d101.svg";
export { ForwardRef as ReactComponent };